import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { RequestInvoiceActionContext } from "./RequestInvoiceActionContext";

function useRequestInvoice() {
  const { element, setBackendFormErrors } = useContext(RequestInvoiceActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update("super-orders/request-invoice", element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useRequestInvoice;
